export const HOST = 'https://psvault.virtualdecision.net/api';

// Firebase project used by the Nura Baby app. The import page signs in here
// (identitytoolkit) so it gets a Firebase idToken whose `sub` is the app user's
// uid — required because RTDB writes authenticate with that token.
export const FIREBASE_PROJECT = 'nura-virtual-decision';
export const FIREBASE_API_KEY = 'AIzaSyDceyQP2wPATgAuew5EjOXle8-SlUFR_F4';

export const ENDPOINTS = {
    getShoppingLists: "/get-shopping-list",
    deleteShoppingList: "/delete-shopping-list",
    getShoppingListItems: "/get-shopping-list-items",
    updateShoppingLists: "/update-shopping-list",
    updateShoppingListItem: "/update-shopping-list-item",
    deleteShoppingListItem: "/delete-shopping-list-item",
    createShoppingList: "/create-shopping-list",
    createShoppingListItem: "/create-shopping-list-item",
    updateSelectedShoppingList: "/update-selected-shopping-id",
    updateSelectedVault: "/update-selected-vault-id",
    updateSelectedRecipeBook: "/update-selected-recipe-book-id",
    getVault: "/get-vault",
    createVault: "/create-vault",
    updateVault: "/update-vault",
    deleteVault: "/delete-vault",
    shareVault: "/share-vault",
    unshareVault: "/unshare-vault",
    getVaultShareUsers: "/get-vault-share-users",
    createVaultItem: "/create-vault-item",
    getVaultItems: "/get-vault-items",
    updateVaultItem: '/update-vault-item',
    deleteVaultItem: '/delete-vault-item',
    revealVaultItem: '/reveal-vault-item',
    enableVaultItemTotp: '/enable-vault-item-totp',
    getVaultItemTotpCode: '/get-vault-item-totp-code',
    disableVaultItemTotp: '/disable-vault-item-totp',
    getVaultItemHistory: '/get-vault-item-history',
    restoreVaultItemVersion: '/restore-vault-item-version',
    getVaults: '/get-vaults',
    getMe: '/me',
    getUsers: '/get-users',
    createUser: '/create-user',
    updateUser: '/update-user',
    deleteUser: '/delete-user',
    lookupUserByEmail: '/lookup-user-by-email',
    assignVaultToUser: '/assign-vault-to-user',
    removeVaultFromUser: '/remove-vault-from-user',
    // ==================== RECIPE BOOKS ====================
    createRecipeBook: '/create-recipe-book',
    getRecipeBooks: '/get-recipe-books',
    updateRecipeBook: '/update-recipe-book',
    deleteRecipeBook: '/delete-recipe-book',
    shareRecipeBook: '/share-recipe-book',
    unshareRecipeBook: '/unshare-recipe-book',
    getRecipeBookShareUsers: '/get-recipe-book-share-users',
    // ==================== RECIPES ====================
    getRecipesByBook: '/get-recipes-by-book',
    getRecipesFromAllBooks: '/get-recipes-from-all-books',
    getRecipesFromAllBooksList: '/get-recipes-from-all-books-list',
    getRecipeDetail: '/get-recipe-detail',
    generateShareToken: '/generate-share-token',
    revokeShareToken: '/revoke-share-token',
    addRecipe: '/add-recipe',
    updateRecipe: '/update-recipe',
    deleteRecipe: '/delete-recipe',
    // ==================== INGREDIENTS ====================
    addIngredient: '/add-ingredient',
    updateIngredient: '/update-ingredient',
    deleteIngredient: '/delete-ingredient',
    // ==================== IMPORTS ====================
    importRecipeUrl: '/import-recipe-url',
    importRecipeText: '/import-recipe-text',
    uploadRecipeImage: '/upload-recipe-image',
    importRecipeHtml: '/import-recipe-html',
    // ==================== CATEGORIES ====================
    getCategories: '/get-categories',
    getRecipesByCategory: '/get-recipes-by-category',
    searchRecipes: '/search-recipes',
    assignCategoriesToRecipe: '/assign-categories-to-recipe',
    getCategoryStats: '/get-category-stats',
    // ==================== AUTHENTIK ====================
    authentikLoginUrl: '/auth/authentik/login-url',
    authentikRefresh: '/auth/authentik/refresh',
    // ==================== NURA BABY ====================
    nuraImport: '/nura/import',
};